/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/survey/export_responses" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementAppGroupIdSurveyExportResponsesCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdSurveyExportResponsesProps,
  PostEngagementAppGroupIdSurveyExportResponsesResult,
  PostEngagementAppGroupIdSurveyExportResponsesResultErrors,
} from "./types";

export const postEngagementAppGroupIdSurveyExportResponses = reactQueryMutationAdapter(
  postEngagementAppGroupIdSurveyExportResponsesCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEngagementAppGroupIdSurveyExportResponsesResultErrors>()(
    ({
      campaignBaseId,
      messageVariantId,
      landingPageId,
      startDate,
      endDate,
      appGroupId,
    }: PostEngagementAppGroupIdSurveyExportResponsesProps): Promise<PostEngagementAppGroupIdSurveyExportResponsesResult> => {
      const body = {
        campaign_base_id: campaignBaseId,
        message_variation_id: messageVariantId,
        landing_page_id: landingPageId,
        start_date: startDate,
        end_date: endDate,
      };

      return fetch(`/engagement/${appGroupId}/survey/export_responses`, "POST", body, undefined, {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      });
    }
  )
);
